export default {
    namespaced: true,
    state: {
        scenario_person_visit_list_page_ids: {}
    },
    mutations: {
        // person_visit_list用のページIDをセット
        setScenarioPersonVisitListPageIds(state, person_visit_list_page_ids) {
            state.scenario_person_visit_list_page_ids = person_visit_list_page_ids;
        }
    },
    actions: {},
    getters: {
        // シナリオperson_visit_list用のページIDを取得
        getScenarioPersonVisitListPageIds(state) {
            return state.scenario_person_visit_list_page_ids;
        }
    }
};
